import { decodeTCString, parseTCCore } from "../utils";
function getCurrentState() {
    // TODO: Validate before return
    return window.gravitocmp.currentstate;
}
function getVendorConsentsPrivate() {
    const currentState = getCurrentState();
    return currentState.whiteListVendors.consent;
}
function getNonTCFVendorConsentsPrivate() {
    const currentState = getCurrentState();
    return currentState.nonTCFVendors.reduce((acc, current) => {
        return { ...acc, [current.id]: current.consent };
    }, {});
}
async function getConsentStringPrivate() {
    return new Promise((resolve, reject) => {
        try {
            if (!window.__tcfapi) {
                reject({ error: "__tcfapi not available" });
            }
            window.__tcfapi("getTCData", 2, (tcData, success) => {
                if (success && tcData.tcString) {
                    resolve(tcData.tcString);
                }
                else {
                    reject(new Error("invalid query"));
                }
            });
        }
        catch (e) {
            reject({ error: e });
        }
    });
}
async function getTCFCore() {
    const cs = await getConsentStringPrivate();
    const decodedConsent = decodeTCString(cs);
    if (!decodedConsent) {
        return undefined;
    }
    return parseTCCore(decodedConsent);
}
async function getPublisherConsentsPrivate() {
    const currentState = getCurrentState();
    const publisherConsents = {
        standard: currentState.purposes.consent,
        custom: currentState.customPurposes.consent,
        specialFeature: currentState.specialFeatures,
        vendors: getVendorConsentsPrivate(),
        nonTCFVendors: getNonTCFVendorConsentsPrivate(),
        core: await getTCFCore(),
    };
    return publisherConsents;
}
export { getPublisherConsentsPrivate, getVendorConsentsPrivate, getNonTCFVendorConsentsPrivate, getConsentStringPrivate, };
//# sourceMappingURL=alma-api.js.map